import { computed, defineComponent, inject, useCssModule, reactive } from '@nuxtjs/composition-api';
import { getWealthTitle } from '~/utils';
import { BODY_TITLE_MAP } from '~/components/ProfilePerson/index';
export default defineComponent({
    name: 'ProfilePerson',
    props: {
        pageOffset: {
            default: 0,
            type: Number,
        },
    },
    setup() {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Profile.
         */
        const profile = inject('profile');
        /**
         * First rating.
         */
        const [firstRating = null] = profile.value?.ratings || [];
        const profileType = profile.value?.profile_type || '';
        const isCompany = profileType === 'company';
        const isMan = profileType === 'man';
        const isSchool = profileType === 'school';
        const bodyTitle = BODY_TITLE_MAP[profileType] || 'Факты';
        const wealthTitle = getWealthTitle(profileType);
        const wealthString = `Как ${isMan ? 'менялось' : 'менялась'} ${wealthTitle.toLowerCase()}`;
        const wealths = profile.value.wealths?.length
            ? profile.value.wealths
            : profile.value.ratings?.reduce((acc, rating) => {
                if (rating.wealth) {
                    acc?.unshift({
                        val: Number(rating.wealth),
                        year: Number(rating.year),
                    });
                }
                return acc;
            }, []) || [];
        const changedDate = new Date(profile.value.changed * 1000).toLocaleDateString('ru-RU');
        const currentWealth = computed(() => {
            if (wealths.length) {
                return wealths[wealths.length - 1];
            }
            if (profile.value?.revenue) {
                return profile.value.revenue;
            }
            return null;
        });
        const ratingFrom200 = computed(() => {
            const { ratingTop200, ratings } = profile.value;
            if (!ratingTop200 || !ratings.length) {
                return null;
            }
            return ratings.find((rating) => rating.id === ratingTop200.id);
        });
        const otherRatings = computed(() => {
            const id = ratingFrom200.value ? ratingFrom200.value.id : firstRating?.id;
            if (!id) {
                return [];
            }
            return profile.value.ratings.filter((rating) => rating.id !== id);
        });
        const currentRating = computed(() => {
            return ratingFrom200.value || firstRating || null;
        });
        const otherRatingsTooltip = reactive({
            buttonText: computed(() => (otherRatingsTooltip.isListToggled ? 'Скрыть' : 'Еще')),
            isToggled: false,
            isListToggled: false,
            slice: 3,
            toggle: () => {
                otherRatingsTooltip.isToggled = !otherRatingsTooltip.isToggled;
                otherRatingsTooltip.isListToggled = false;
            },
            toggleList: () => {
                otherRatingsTooltip.isListToggled = !otherRatingsTooltip.isListToggled;
            },
        });
        return {
            bodyTitle,
            css,
            currentRating,
            currentWealth,
            firstRating,
            isCompany,
            isMan,
            isSchool,
            changedDate,
            getWealthTitle,
            otherRatings,
            otherRatingsTooltip,
            profile,
            ratingFrom200,
            wealthString,
            wealthTitle,
            wealths,
        };
    },
});
